import { z } from 'zod';

/** Offset pagination contract shared with the FastAPI backend. `page` is 1-based. */
export const pageSchema = <T extends z.ZodType>(item: T) =>
  z.object({
    items: z.array(item),
    page: z.number().int().min(1),
    pageSize: z.number().int().min(1),
    total: z.number().int().min(0),
    totalPages: z.number().int().min(0),
  });

export type Page<T> = { items: T[]; page: number; pageSize: number; total: number; totalPages: number };

export const PAGE_SIZE_OPTIONS = [10, 25, 50] as const;
